import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('history', {
    url: '/history',
    templateProvider: () =>
      import(/* webpackChunkName: "gpsHistory" */ './gpsHistory.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'gpsHistoryCtrl as vm',
    // requiredPermission: 'gpsHistory',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "history" */ './gpsHistory.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
          import('../../extensions/directives/date-range-picker'),
          import('../../extensions/directives/rome'),
          import('../../extensions/directives/validator-date'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.gpsHistory.routing', []).config(routes);
